'use client';

import { Button } from '@zillow/constellation-10';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { usePathname } from '@/src/i18n/navigation';
import GoogleGlyph from '@/src/components/ui/icons/GoogleGlyph';
import { replaceOnSameTabClick } from '@/src/lib/auth/provider-navigation';

type GoogleSignInButtonProps = {
  postLoginRedirect?: string;
};

export function GoogleSignInButton({ postLoginRedirect }: GoogleSignInButtonProps) {
  const t = useTranslations('auth');
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString();
  const currentPath = search ? `${pathname}?${search}` : pathname;
  const startUrl = `/api/auth/google/start?redirect=${encodeURIComponent(postLoginRedirect ?? currentPath)}`;

  return (
    <Button asChild tone="neutral" emphasis="outlined" size="lg" fluid icon={<GoogleGlyph />}>
      <a
        href={startUrl}
        onClick={(event) => {
          replaceOnSameTabClick(event, startUrl, pathname);
        }}
      >
        {t('continueWithGoogle')}
      </a>
    </Button>
  );
}
